import { render, staticRenderFns } from "./ManageAvenant.vue?vue&type=template&id=3491d516&scoped=true"
import script from "./ManageAvenant.vue?vue&type=script&lang=ts"
export * from "./ManageAvenant.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3491d516",
  null
  
)

export default component.exports